/**
 * Route Planner copy set: the Indonesian strings of the planner surfaces
 * (drawer + builder) that tests assert on. The stop-kind labels themselves
 * come from `services/api/routeStopKind.ts` (one label set app-wide).
 */
export const ROUTE_PLANNER_COPY = {
  builder: {
    /** The client rule banner at the top of the builder. */
    clientRuleCharged: 'Aturan client: leg pool ditagih.',
    clientRuleUncharged: 'Aturan client: leg pool tidak ditagih.',
    clientRuleCaption:
      'Stop pertama dan terakhir adalah pool. Ditagih atau tidak mengikuti aturan client, kecuali diatur lewat Ditagih ke client pada stop itu.',
    // ── Per-stop billing (CR-8) ───────────────────────────────────────────
    chargedControl: 'Ditagih ke client',
    chargedFollowRule: 'Kembali ke aturan client',
    chargedYes: 'Ditagih',
    chargedNo: 'Tidak ditagih',
    clientRuleLine: (charged: boolean) =>
      `Aturan client: ${charged ? 'ditagih' : 'tidak ditagih'}`,
    chargedOverride: 'Beda dari aturan client',
    /** CR-8b: both edges derived as pool, the server will reject the route. */
    allPoolHint:
      'Rute hanya punya leg pool; nyalakan Ditagih ke client pada stop pertama/terakhir.',
    // ── Workflow pin hints ────────────────────────────────────────────────
    workflowHintDefault:
      'Kosong = workflow default client dipakai saat shipment dibuat.',
    workflowHintPool:
      'Stop pool ikut masuk shipment; workflow ini dipakai driver di stop pool.',
    kmAllLegs: 'KM semua leg',
    kmCharged: 'KM ditagih',
  },
} as const;
